import { useMemo } from "react"
import { useGet } from "utils/useFetch"
import type { IWorkplaceRes } from "../typings"
import type { SetupWorkplace } from "../setup/components/SetupWorkplaceList"

const WORKPLACES_PAGE_SIZE = 10

type Params = {
  page: number
  search: string
}

export function useWorkplacesList({ page, search }: Params) {
  const workplacesQueryParams = new URLSearchParams({
    page: String(page),
    limit: String(WORKPLACES_PAGE_SIZE),
    ...(search && { keyword: search }),
  }).toString()

  const { data: workplaceRes, isFetching: isWorkplacesFetching } =
    useGet<IWorkplaceRes>({
      url: `/v1/time-attendance/workplaces?${workplacesQueryParams}`,
      instanceKey: "ewaAxiosInstance",
    })

  const workplaces: SetupWorkplace[] = useMemo(() => {
    const docs = workplaceRes?.data?.docs ?? []
    return docs.map((doc) => {
      const lat = doc.latitude != null ? parseFloat(doc.latitude) : null
      const lng = doc.longitude != null ? parseFloat(doc.longitude) : null

      return {
        id: String(doc.id),
        name: doc.displayName || doc.fullAddress || "Workplace",
        description: "Primary duty location:",
        address: doc.fullAddress || "",
        latitude: Number.isNaN(lat) ? null : lat,
        longitude: Number.isNaN(lng) ? null : lng,
        workplaceConfig: doc.workplaceConfig ?? null,
      }
    })
  }, [workplaceRes])

  return {
    workplaces,
    total: workplaceRes?.data?.totalDocs ?? 0,
    isWorkplacesFetching,
    workplacesQueryParams,
  }
}
